import Vue from 'vue'
import Vuex from "vuex"

import { auth } from '../db'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        user: {
            loggedIn: false,
            data: null
        },
        page: {
            color: 'red',
            name: ''
        }
    },
    getters: {
        user(state){
            return state.user
        },
        userId(state) {
            if (state.user.data) {
                return state.user.data.email
            } else {
                return 'myuser'
            }
        }
    },
    mutations: {
        setLoggedIn(state, value) {
            state.user.loggedIn = value;
        },
        setUser(state, data) {
            state.user.data = data
        },
        setPageName(state, names) {
            state.page.name = names
        }
    },
    actions: {
        fetchUser({ commit }, user) {
            commit("setLoggedIn", user !== null);
            if (user) {
                commit("setUser", user);
            } else {
                commit("setUser", null);
            }
        },
        updatePageName({ commit }, names) {
            if (!names || names.length == 0 || !names[0].name) {
                return
            }
            commit("setPageName", names)
            if (names && names.length > 0 && names[0].name) {
                var title = names[names.length - 1].name
                if (names.length > 1) {
                    title += ' ' + names[names.length - 2].name
                }
                if (title) {
                    document.title = title + ' | Monroe'
                } else {
                    document.title = 'Monroe'
                }
            } else {
                document.title = 'Monroe'
            }
        }
    }
})

auth.onAuthStateChanged(function (firebaseUser) {
    store.dispatch("fetchUser", firebaseUser)
})